import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory } from "react-router-dom";
import { useParams, useRouteMatch } from "react-router";

import { ErrorState, LoadingState } from "../../components/status/StatusView";
import { loadRequest } from "../../utils/loadRequest";
import ContentGrid from "../../components/contentGrid";
import useQuery from "../../utils/useQuery";
import carouselImg from "../../assets/icons/svg/Icon awesome-angle-right.svg";
import { getVodsByLabel } from "../../api/vod/vod";
import { getRecordedList, getWillBeRecordedList } from "../../api/npvr/npvr";

const GridView = ({ dontUseGrid }) => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const requestVersion = useRef(0);
  const pending = useRef(false);

  const { columnCode, columnName } = useParams();

  const history = useHistory();

  const pageRef = useRef(0);
  const itemsRef = useRef([]);
  const totalCountRef = useRef(0);

  let query = useQuery();
  let posterPosition = query.get("poster");

  let pageItemCount = 20; // request for other pages vod count

  useEffect(() => {
    window.scrollTo(0, 0);
    requestVersion.current++;
    pageRef.current = 0;
    itemsRef.current = [];
    pending.current = false;
    setItems([]);
    setError(false);
    setHasMore(true);
    if (columnCode === "record") getRecords();
    else getItems();
    return () => {
      requestVersion.current++;
    };
  }, [columnCode]);

  const getItems = async () => {
    if (pending.current) return;
    const version = requestVersion.current;
    pending.current = true;
    setLoading(true);
    setError(false);
    try {
      const { data } = await loadRequest((options) =>
        getVodsByLabel(columnCode, pageRef.current, pageItemCount, options)
      );
      if (version !== requestVersion.current) return;
      const listItems =
        Array.isArray(data?.channels) && data.channels.length
          ? data.channels
          : Array.isArray(data?.contents)
          ? data.contents
          : data?.channels;
      if (!Array.isArray(listItems))
        throw new Error("Invalid collection response");
      pageRef.current++;
      itemsRef.current = itemsRef.current.concat(listItems);
      totalCountRef.current = data?.totalContents;
      setItems(itemsRef.current);
      setHasMore(
        listItems.length > 0 &&
          (typeof data?.totalContents === "number"
            ? itemsRef.current.length < data.totalContents
            : listItems.length === pageItemCount)
      );
    } catch (failure) {
      if (version === requestVersion.current) {
        setError(failure);
        setHasMore(false);
      }
    } finally {
      if (version === requestVersion.current) {
        pending.current = false;
        setLoading(false);
      }
    }
  };

  const getRecords = async () => {
    if (pending.current) return;
    pending.current = true;
    setLoading(true);
    setError(false);
    const version = requestVersion.current;
    try {
      const [recorded, scheduled] = await loadRequest((options) =>
        Promise.all([getRecordedList(options), getWillBeRecordedList(options)])
      );
      if (version !== requestVersion.current) return;
      setItems([
        ...(Array.isArray(recorded?.data) ? recorded.data : []),
        ...(Array.isArray(scheduled?.data) ? scheduled.data : [])
      ]);
      setHasMore(false);
    } catch (failure) {
      if (version === requestVersion.current) {
        setError(failure);
        setHasMore(false);
      }
    } finally {
      if (version === requestVersion.current) {
        pending.current = false;
        setLoading(false);
      }
    }
  };

  //bu view komponent gridi yönetecek. Gridin datası burada alınacak ve contentGrid komponentine gönderilecek.
  return (
    <main className="cinema-grid-page">
      <div
        className="label-title"
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Enter") history.goBack();
        }}
        onClick={() => {
          history.goBack();
        }}
      >
        <img className="go-back-icon" src={carouselImg} />
        {columnName}
      </div>

      {error && !items.length && (
        <ErrorState
          size="compact"
          error={error}
          onRetry={columnCode === "record" ? getRecords : getItems}
        />
      )}
      {loading && !items.length && <LoadingState size="compact" />}
      <InfiniteScroll
        dataLength={items?.length}
        next={getItems}
        hasMore={hasMore}
      >
        <ContentGrid
          items={items}
          posterPosition={posterPosition}
          columnCode={columnCode}
          refreshContents={(val) => {
            if (val) {
              getRecords();
            }
          }}
        />
      </InfiniteScroll>
      {loading && !!items.length && <LoadingState size="compact" />}
      {error && !!items.length && (
        <ErrorState
          size="compact"
          error={error}
          onRetry={columnCode === "record" ? getRecords : getItems}
        />
      )}
    </main>
  );
};

export default GridView;
